import qs from 'qs';
import { network } from 'services/network';

import { QueryParams } from 'api/queries/getSubProgramPreferencePartialCompletion.query';

export const getSubProgramPreferencePartialCompletion = (params: QueryParams) => {
    const querystring = qs.stringify(params, { addQueryPrefix: true, skipNulls: true });
    const url = `api/bo/getSubProgramPreferencePartialCompletion${querystring}`;
    return network.get(url).then((response) => response.data);
};
